<template>
  <div>
    <h2 class="secondary--text mb-3 mt-5">Familiestatuut App</h2>
    <div class="body-1 grey--text text--darken-2">
      Familiestatuut App, de consultancy methode van de toekomst...
    </div>
  </div>
</template>

<script>
export default {
  name: "headerB",
};
</script>

<style scoped></style>
